import { CSSTransitionGroup } from 'react-transition-group'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const OverflowContainer = styled.div`
  overflow: hidden;
  padding: 4px;
  position: relative;
`
const Container = styled.div`
  padding: 0;
  margin: 0;
  position: relative;

  &.swipe-right-enter {
    transform: translate(100%);
  }

  &.swipe-right-leave {
    transform: translate(0%);
    position: absolute;
    top: 0;
  }

  &.swipe-right-leave.swipe-right-leave-active {
    transform: translate(-120%);
    transition: ${({ duration }) => `transform ${duration}ms ease-in-out, 
      opacity 100ms ease-in-out`};
    opacity: 1;
  }

  &.swipe-right-enter.swipe-right-enter-active {
    transform: translate(0%);
    transition: ${({ duration }) => `transform ${duration}ms ease-in-out`};
  }

  &.swipe-left-enter {
    transform: translate(-100%);
    width: 100%;
  }

  &.swipe-left-enter.swipe-left-enter-active {
    transform: translate(0%);
    opacity: 1;
    transition: ${({ duration }) => `transform ${duration}ms ease-in-out`};
  }

  &.swipe-left-leave {
    transform: translate(0%);
    transition: ${({ duration }) => `transform ${duration}ms ease-in-out, 
      opacity 100ms ease-in-out`};
    opacity: 1;
    width: 100%;
    position: absolute;
    top: 0;
  }

  &.swipe-left-leave.swipe-left-leave-active {
    transform: translate(100%);
  }
`
const SwipeTransition = ({
  moveForward = true,
  appearDuration = 200,
  activeKey,
  children,
  ...rest
}) => {
  return (
    <OverflowContainer {...rest}>
      <CSSTransitionGroup
        transitionEnterTimeout={appearDuration}
        transitionLeaveTimeout={appearDuration}
        transitionName={moveForward ? 'swipe-right' : 'swipe-left'}
        component="div">
        <Container key={activeKey} duration={appearDuration}>
          {children}
        </Container>
      </CSSTransitionGroup>
    </OverflowContainer>
  )
}

SwipeTransition.propTypes = {
  moveForward: PropTypes.bool,
  appearDuration: PropTypes.number,
  activeKey: PropTypes.string
}

export { SwipeTransition }
